if (!customElements.get('koyo-collection-more')) {
  customElements.define('koyo-collection-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      this.visited = new Set();
      this.onClick = (event) => { event.preventDefault(); this.load(); };
      this.onReset = () => { this.stopped = true; this.controller?.abort(); this.observer?.disconnect(); };
      this.link?.addEventListener('click', this.onClick);
      if (this.dataset.autoComplete === 'true') {
        if (this.link) queueMicrotask(() => this.load());
        else queueMicrotask(() => this.updateReviewedCount());
      }
      document.addEventListener('koyo:collection-reset', this.onReset);
      if ('IntersectionObserver' in window && this.link) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting) && !this.failed) this.load();
        }, { rootMargin: '400px' });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.onReset();
      document.removeEventListener('koyo:collection-reset', this.onReset);
      this.link?.removeEventListener('click', this.onClick);
    }

    updateReviewedCount() {
      const grid = document.getElementById('product-grid');
      if (!grid?.dataset.reviewedShape) return;
      const label = grid.dataset.countLabel.replace('COUNT', grid.children.length);
      document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((item) => { item.textContent = label; });
    }

    async load() {
      if (this.busy || this.stopped || !this.link || this.link.hidden) return;
      const grid = document.getElementById('product-grid');
      const url = new URL(this.link.href, location.href);
      if (!grid || url.origin !== location.origin || url.pathname !== location.pathname || this.visited.has(url.href)) return;
      const context = location.href;
      this.busy = true;
      this.failed = false;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.link.setAttribute('aria-disabled', 'true');
      this.controller = new AbortController();
      try {
        url.searchParams.set('section_id', grid.dataset.id);
        const response = await fetch(url.href, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || this.stopped || context !== location.href || grid !== document.getElementById('product-grid')) return;
        const incoming = page.getElementById('product-grid');
        const more = page.querySelector('koyo-collection-more');
        if (!incoming || !more) throw new Error('Collection response incomplete');
        const ids = new Set(Array.from(grid.children, (item) => item.dataset.productId));
        for (const item of Array.from(incoming.children)) {
          if (!item.dataset.productId || ids.has(item.dataset.productId)) continue;
          ids.add(item.dataset.productId);
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('img').forEach((image) => { image.loading = 'lazy'; });
          grid.append(item);
        }
        this.visited.add(this.link.href);
        const next = more.querySelector('a');
        if (next) {
          this.link.href = new URL(next.getAttribute('href'), location.href).href;
          this.status.textContent = '';
        } else {
          this.link.hidden = true;
          this.status.textContent = this.dataset.complete;
          this.updateReviewedCount();
          this.observer?.disconnect();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.failed = true;
          this.status.textContent = this.dataset.error;
        }
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.link?.removeAttribute('aria-disabled');
        if (this.dataset.autoComplete === 'true' && !this.failed && !this.stopped && !this.link?.hidden) queueMicrotask(() => this.load());
      }
    }
  });
}
